import { motion } from "framer-motion";
import { CallButton } from "@/components/CallButton";

export const PageHero = ({ overline, title, description, showCall = true }) => (
  <section className="grain relative overflow-hidden bg-ink pt-[72px]" data-testid="page-hero">
    <div className="blueprint-grid absolute inset-0 opacity-40" />
    <div className="pointer-events-none absolute -right-32 top-0 h-[420px] w-[420px] rounded-full bg-gold/[0.06] blur-[120px]" />
    <div className="relative z-10 mx-auto max-w-[1440px] px-5 py-16 md:px-8 md:py-24">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="mb-6 flex items-center gap-3 font-heading text-xs font-bold uppercase tracking-[0.2em] text-gold"
      >
        <span className="h-px w-8 bg-gold" />
        {overline}
      </motion.div>
      <motion.h1
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-4xl font-heading text-4xl font-black uppercase leading-[0.95] tracking-tightest text-white sm:text-5xl lg:text-6xl"
      >
        {title}
      </motion.h1>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.6 }}
          className="mt-6 max-w-2xl text-lg leading-relaxed text-steel"
        >
          {description}
        </motion.p>
      )}
      {showCall && (
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.25, duration: 0.6 }}
          className="mt-9"
        >
          <CallButton size="lg" showNumber testid="page-hero-call-btn" />
        </motion.div>
      )}
    </div>
  </section>
);
